/* Medicus — custom fabric repeat preview
 * ---------------------------------------------------------------------------
 * Sits under the YMQ upload field 548tem1 ("Custom Fabric Pattern For Your
 * Scrub Cap") on the custom printed fabric listing. Takes the image(s) the
 * customer has just uploaded, tiles them the way fabric is printed (straight,
 * half-drop, half-brick, mirror), lets them zoom, shows the tile edges, and
 * checks whether the edges of the tile actually meet.
 *
 * WHAT IT READS: the thumbnails YMQ puts in .ymq-option-preview-list (blob:
 * URLs of the file the customer chose, so pixels can be read for the seam
 * check without any network).
 *
 * WHAT IT WRITES: one hidden input, properties[Pattern repeat], in every
 * /cart/add form, carrying the repeat the customer picked and what the seam
 * check saw. It never selects a YMQ option, never touches the paid "edits"
 * radios, and removes its own input when the uploads are removed.
 *
 * If anything here throws, the catch leaves YMQ's upload exactly as it was.
 * --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var FIELD_ID = '548tem1';
  var FIELD_LABEL = /custom fabric pattern/i;
  var PROP_NAME = 'properties[Pattern repeat]';
  var ANALYSE_MAX = 240;   /* long side, px, for the seam check */

  var MODES = [
    { key: 'straight',   label: 'Straight' },
    { key: 'half-drop',  label: 'Half-drop' },
    { key: 'half-brick', label: 'Half-brick' },
    { key: 'mirror',     label: 'Mirror' }
  ];

  var state = {
    images: [],          /* { id, name, src, img, ready, broken, verdicts:{} } */
    active: 0,
    mode: 'straight',
    across: 4,
    edges: false
  };

  var ui = null;
  var cfg = null;

  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function fmt(s, map) {
    return String(s).replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  function readConfig() {
    var node = document.querySelector('[data-mc-repeat-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* Id first, label second: renaming the option in YMQ must not break this. */
  function findBox() {
    var byId = document.querySelector('.ymq-options-box[ymq-option-id="' + FIELD_ID + '"]');
    if (byId) return byId;
    var boxes = all('.ymq-options-box[ymq-option-type="12"]');
    for (var i = 0; i < boxes.length; i++) {
      if (FIELD_LABEL.test(boxes[i].getAttribute('ymq-option-label') || '')) return boxes[i];
    }
    return null;
  }

  /* ---- the hidden property ------------------------------------------- */
  function modeLabel(key) {
    for (var i = 0; i < MODES.length; i++) if (MODES[i].key === key) return MODES[i].label;
    return key;
  }
  function writeProperty() {
    var forms = all('form[action*="/cart/add"]');
    var cur = state.images[state.active];
    var value = '';
    if (cur && cur.ready) {
      var v = cur.verdicts[state.mode];
      var tail = !v ? '' : v.status === 'clean' ? ' (edges joined cleanly in preview)'
               : v.status === 'seam' ? ' (preview showed a visible join: ' + v.sides.join(', and ') + ')'
               : v.status === 'mirror' ? ' (reflected tiles, always joins)'
               : ' (edges not checked)';
      value = modeLabel(state.mode) + ' repeat' + tail;
      if (state.images.length > 1) value += ' [' + (cur.name || 'image ' + (state.active + 1)) + ']';
    }
    forms.forEach(function (f) {
      var input = f.querySelector('input[data-mc-repeat-prop]');
      if (!value) { if (input) input.parentNode.removeChild(input); return; }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PROP_NAME;
        input.setAttribute('data-mc-repeat-prop', '');
        f.appendChild(input);
      }
      input.value = value;
    });
  }

  /* ---- seam check ----------------------------------------------------- */
  function analyse(entry, mode) {
    if (entry.verdicts[mode]) return entry.verdicts[mode];
    var v;
    if (mode === 'mirror') {
      v = { status: 'mirror', sides: [] };
    } else {
      v = seamCheck(entry, mode);
    }
    entry.verdicts[mode] = v;
    return v;
  }

  function pixels(entry) {
    if (entry._px !== undefined) return entry._px;
    try {
      var img = entry.img;
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) { entry._px = null; return null; }
      var s = Math.min(1, ANALYSE_MAX / Math.max(w, h));
      var cw = Math.max(4, Math.round(w * s)), ch = Math.max(4, Math.round(h * s));
      var c = document.createElement('canvas');
      c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#fff';               /* transparent areas print as the base fabric; treat as white */
      x.fillRect(0, 0, cw, ch);
      x.drawImage(img, 0, 0, cw, ch);
      var d = x.getImageData(0, 0, cw, ch).data;
      entry._px = { d: d, w: cw, h: ch };
    } catch (e) {
      entry._px = null;                    /* tainted canvas (cross-origin restore) */
    }
    return entry._px;
  }

  function px(p, x, y) {
    var i = ((y * p.w) + x) * 4;
    return [p.d[i], p.d[i + 1], p.d[i + 2]];
  }
  function dist(a, b) {
    return (Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2])) / 3;
  }
  /* mean difference between column xa and column xb, with xb read `dy` rows further down (wrapping) */
  function colDiff(p, xa, xb, dy) {
    var sum = 0;
    for (var y = 0; y < p.h; y++) sum += dist(px(p, xa, y), px(p, xb, (y + dy) % p.h));
    return sum / p.h;
  }
  function rowDiff(p, ya, yb, dx) {
    var sum = 0;
    for (var x = 0; x < p.w; x++) sum += dist(px(p, x, ya), px(p, (x + dx) % p.w, yb));
    return sum / p.w;
  }

  function seamCheck(entry, mode) {
    var p = pixels(entry);
    if (!p) return { status: 'unknown', sides: [] };
    var W = p.w, H = p.h;
    var dy = mode === 'half-drop' ? Math.floor(H / 2) : 0;
    var dx = mode === 'half-brick' ? Math.floor(W / 2) : 0;

    /* how much neighbouring columns / rows differ inside the image, so a busy
       texture is not mistaken for a seam and a flat one is not let off */
    var bc = 0, br = 0, n = 0, k;
    for (k = 1; k <= 8; k++) {
      var xs = Math.max(1, Math.floor(W * k / 9)), ys = Math.max(1, Math.floor(H * k / 9));
      bc += colDiff(p, xs - 1, xs, 0);
      br += rowDiff(p, ys - 1, ys, 0);
      n++;
    }
    bc /= n; br /= n;

    var seamLR = colDiff(p, W - 1, 0, dy);          /* right edge meeting the left edge of the next tile */
    var seamTB = rowDiff(p, H - 1, 0, dx);          /* bottom edge meeting the top of the tile below */

    var flag = function (seam, base) {
      if (seam < cfg.thresholds.absolute_ok) return false;        /* tiny difference: fine whatever the texture */
      return seam > Math.max(base * cfg.thresholds.ratio, cfg.thresholds.absolute_min);
    };
    var sides = [];
    if (flag(seamLR, bc)) sides.push(cfg.copy.side_lr);
    if (flag(seamTB, br)) sides.push(cfg.copy.side_tb);
    return { status: sides.length ? 'seam' : 'clean', sides: sides, lr: seamLR, tb: seamTB, bc: bc, br: br };
  }

  /* ---- drawing -------------------------------------------------------- */
  var raf = 0;
  function requestDraw() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; draw(); });
  }

  function draw() {
    if (!ui) return;
    var cur = state.images[state.active];
    var canvas = ui.canvas;
    var cssW = ui.stage.clientWidth;
    if (!cur || !cur.ready || !cssW) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var cssH = Math.round(cssW * 0.68);
    if (canvas.width !== Math.round(cssW * dpr) || canvas.height !== Math.round(cssH * dpr)) {
      canvas.width = Math.round(cssW * dpr);
      canvas.height = Math.round(cssH * dpr);
    }
    canvas.style.height = cssH + 'px';
    var x = canvas.getContext('2d');
    x.setTransform(dpr, 0, 0, dpr, 0, 0);
    x.fillStyle = '#fff';
    x.fillRect(0, 0, cssW, cssH);

    var img = cur.img;
    var ts = cssW / state.across;
    var th = ts * img.naturalHeight / img.naturalWidth;
    if (!(th > 0)) return;
    var mode = state.mode;
    var cols = Math.ceil(cssW / ts) + 2, rows = Math.ceil(cssH / th) + 2;
    var half = function (i) { return ((i % 2) + 2) % 2 === 1; };

    x.imageSmoothingEnabled = true;
    x.imageSmoothingQuality = 'high';
    for (var i = -1; i < cols; i++) {
      for (var j = -1; j < rows; j++) {
        var px0 = i * ts, py0 = j * th;
        if (mode === 'half-drop' && half(i)) py0 += th / 2;
        if (mode === 'half-brick' && half(j)) px0 += ts / 2;
        if (px0 > cssW || py0 > cssH || px0 + ts < 0 || py0 + th < 0) continue;
        /* snap every tile to whole pixels, ending where the next one starts,
           so no hairline of white shows between fractional edges */
        var ix = Math.floor(px0), iy = Math.floor(py0);
        var iw = Math.ceil(px0 + ts) - ix, ih = Math.ceil(py0 + th) - iy;
        if (mode === 'mirror') {
          var fx = half(i) ? -1 : 1, fy = half(j) ? -1 : 1;
          x.save();
          x.translate(ix + (fx < 0 ? iw : 0), iy + (fy < 0 ? ih : 0));
          x.scale(fx, fy);
          x.drawImage(img, 0, 0, iw, ih);
          x.restore();
        } else {
          x.drawImage(img, ix, iy, iw, ih);
        }
        if (state.edges) {
          x.save();
          x.strokeStyle = 'rgba(11,35,177,0.65)';
          x.lineWidth = 1;
          x.setLineDash([4, 3]);
          x.strokeRect(px0 + 0.5, py0 + 0.5, ts - 1, th - 1);
          x.restore();
        }
      }
    }
  }

  /* ---- verdict + controls ---------------------------------------------- */
  function renderVerdict() {
    var cur = state.images[state.active];
    var box = ui.verdict;
    box.className = 'mc-repeat__verdict';
    if (!cur || !cur.ready) { box.hidden = true; return; }
    var v = analyse(cur, state.mode);
    var c = cfg.copy;
    var title, body;
    if (v.status === 'clean') { title = c.clean_title; body = c.clean_body; box.classList.add('is-clean'); }
    else if (v.status === 'seam') { title = fmt(c.seam_title, { sides: v.sides.join(', and ') }); body = c.seam_body; box.classList.add('is-seam'); }
    else if (v.status === 'mirror') { title = c.mirror_title; body = c.mirror_body; box.classList.add('is-mirror'); }
    else { title = c.unknown_title; body = c.unknown_body; box.classList.add('is-unknown'); }
    ui.verdictTitle.textContent = title;
    ui.verdictBody.textContent = body;
    box.hidden = false;
  }

  function renderThumbs() {
    var strip = ui.thumbs;
    strip.innerHTML = '';
    if (state.images.length < 2) { ui.thumbsWrap.hidden = true; return; }
    ui.thumbsWrap.hidden = false;
    state.images.forEach(function (im, i) {
      var b = el('button', 'mc-repeat__thumb');
      b.type = 'button';
      b.setAttribute('aria-pressed', i === state.active ? 'true' : 'false');
      b.setAttribute('aria-label', fmt(cfg.copy.thumb_label, { n: i + 1, name: im.name || '' }));
      if (i === state.active) b.classList.add('is-on');
      var img = el('img');
      img.src = im.src; img.alt = '';
      b.appendChild(img);
      b.addEventListener('click', function () { state.active = i; update(); });
      strip.appendChild(b);
    });
  }

  function renderModes() {
    all('.mc-repeat__mode', ui.modes).forEach(function (b) {
      var on = b.dataset.mode === state.mode;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function update() {
    if (!ui) return;
    var any = state.images.some(function (im) { return im.ready; });
    var cur = state.images[state.active];
    ui.empty.hidden = any;
    ui.body.hidden = !any;
    if (any && (!cur || !cur.ready)) {
      for (var i = 0; i < state.images.length; i++) if (state.images[i].ready) { state.active = i; break; }
    }
    renderModes();
    renderThumbs();
    renderVerdict();
    ui.wrap.classList.toggle('has-image', any);
    requestDraw();
    writeProperty();
  }

  /* ---- reading YMQ's preview list ------------------------------------- */
  function syncImages(list) {
    var items = all('.ymq-option-preview-item', list);
    var next = [];
    items.forEach(function (item, i) {
      var img = item.querySelector('img.ymq-option-preview-img, img');
      var src = img && img.getAttribute('src');
      if (!src) return;
      var id = item.getAttribute('ymq-option-preview-item') || src;
      var nameEl = item.querySelector('.ymq-option-preview-filename');
      var existing = null;
      for (var k = 0; k < state.images.length; k++) if (state.images[k].id === id && state.images[k].src === src) { existing = state.images[k]; break; }
      if (existing) { next.push(existing); return; }
      var entry = { id: id, name: nameEl ? nameEl.textContent.trim() : '', src: src, img: new Image(), ready: false, broken: false, verdicts: {} };
      if (!/^blob:|^data:/.test(src)) entry.img.crossOrigin = 'anonymous';
      entry.img.onload = function () { entry.ready = true; update(); };
      entry.img.onerror = function () { entry.broken = true; update(); };
      entry.img.src = src;
      next.push(entry);
    });
    var activeId = state.images[state.active] && state.images[state.active].id;
    state.images = next;
    state.active = 0;
    for (var j = 0; j < next.length; j++) if (next[j].id === activeId) { state.active = j; break; }
    update();
  }

  /* ---- build ----------------------------------------------------------- */
  function build() {
    var c = cfg.copy;
    var wrap = el('section', 'mc-repeat');
    wrap.setAttribute('data-mc-repeat-wrap', '');
    wrap.setAttribute('aria-label', c.heading);

    var head = el('div', 'mc-repeat__head');
    head.appendChild(el('h4', 'mc-repeat__title', c.heading));
    head.appendChild(el('p', 'mc-repeat__lede', c.lede));
    wrap.appendChild(head);

    var empty = el('p', 'mc-repeat__empty', c.empty);
    wrap.appendChild(empty);

    var body = el('div', 'mc-repeat__body');
    body.hidden = true;

    var thumbsWrap = el('div', 'mc-repeat__thumbs-wrap');
    thumbsWrap.hidden = true;
    thumbsWrap.appendChild(el('p', 'mc-repeat__label', c.thumbs_label));
    var thumbs = el('div', 'mc-repeat__thumbs');
    thumbs.setAttribute('role', 'group');
    thumbs.setAttribute('aria-label', c.thumbs_label);
    thumbsWrap.appendChild(thumbs);
    body.appendChild(thumbsWrap);

    body.appendChild(el('p', 'mc-repeat__label', c.modes_label));
    var modes = el('div', 'mc-repeat__modes');
    modes.setAttribute('role', 'group');
    modes.setAttribute('aria-label', c.modes_label);
    MODES.forEach(function (m) {
      var b = el('button', 'mc-repeat__mode', (c.modes && c.modes[m.key]) || m.label);
      b.type = 'button';
      b.dataset.mode = m.key;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { state.mode = m.key; update(); });
      modes.appendChild(b);
    });
    body.appendChild(modes);

    var stage = el('div', 'mc-repeat__stage');
    var canvas = el('canvas', 'mc-repeat__canvas');
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', c.canvas_label);
    stage.appendChild(canvas);
    body.appendChild(stage);

    var tools = el('div', 'mc-repeat__tools');
    var zoom = el('label', 'mc-repeat__zoom');
    var zoomText = el('span', 'mc-repeat__zoom-text', c.zoom_label);
    var range = el('input');
    range.type = 'range'; range.min = '2'; range.max = '8'; range.step = '1'; range.value = String(10 - state.across);   /* right = bigger */
    range.setAttribute('aria-label', c.zoom_label);
    range.addEventListener('input', function () { state.across = 10 - (parseInt(range.value, 10) || 6); requestDraw(); });
    zoom.appendChild(zoomText);
    zoom.appendChild(range);
    tools.appendChild(zoom);

    var edges = el('label', 'mc-repeat__edges');
    var cb = el('input'); cb.type = 'checkbox';
    cb.addEventListener('change', function () { state.edges = cb.checked; requestDraw(); });
    edges.appendChild(cb);
    edges.appendChild(el('span', null, c.edges_label));
    tools.appendChild(edges);
    body.appendChild(tools);

    var verdict = el('div', 'mc-repeat__verdict');
    verdict.setAttribute('role', 'status');
    verdict.hidden = true;
    var vt = el('p', 'mc-repeat__verdict-title');
    var vb = el('p', 'mc-repeat__verdict-body');
    verdict.appendChild(vt);
    verdict.appendChild(vb);
    body.appendChild(verdict);

    body.appendChild(el('p', 'mc-repeat__note', c.note));
    wrap.appendChild(body);

    ui = { wrap: wrap, empty: empty, body: body, thumbsWrap: thumbsWrap, thumbs: thumbs, modes: modes,
           stage: stage, canvas: canvas, verdict: verdict, verdictTitle: vt, verdictBody: vb };
    return wrap;
  }

  function mount() {
    if (document.querySelector('[data-mc-repeat-wrap]')) return true;
    var box = findBox();
    if (!box) return false;
    var uploadWrap = box.querySelector('.ymq-option-upload-wrapper');
    var list = box.querySelector('.ymq-option-preview-list');
    if (!uploadWrap || !list) return false;

    var wrap = build();
    uploadWrap.parentNode.insertBefore(wrap, uploadWrap.nextSibling);
    box.classList.add('mc-repeat-box');

    /* Only YMQ's own preview list is watched: it changes a handful of times
       per upload, not on every swatch image the page lazy-loads. */
    try {
      new MutationObserver(function () { syncImages(list); })
        .observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    } catch (e) { /* fall through to the one-off sync */ }
    try {
      if (window.ResizeObserver) new ResizeObserver(function () { requestDraw(); }).observe(wrap);
      else window.addEventListener('resize', requestDraw);
    } catch (e) { window.addEventListener('resize', requestDraw); }

    syncImages(list);

    /* If YMQ ever replaces the option box wholesale, come back: one observer
       on the box's parent, no subtree. */
    try {
      var parent = box.parentElement;
      if (parent && !parent._mcRepeatWatch) {
        parent._mcRepeatWatch = new MutationObserver(function () {
          if (!document.contains(wrap)) { ui = null; try { mount(); } catch (e) { /* leave YMQ alone */ } }
        });
        parent._mcRepeatWatch.observe(parent, { childList: true });
      }
    } catch (e) { /* fine without */ }
    return true;
  }

  /* YMQ renders late and re-renders on its own schedule. Same filter as the
     other mc-* scripts (INP fix, 7 Sept 2026): container-level changes only. */
  var MC_IGNORE_ATTR = '.ymq-option-value,.ymq-option-value-item,.ymq-option-swatches-item,.ymq-option-label,.ymq-option-button-input,img,input,textarea,.search-mega-menu__input';
  var MC_OWN = '[data-mc-fit-card],.mc-fit__check,.mc-emb-cue,.mc-emb-modal,[data-mc-satc],.mc-tellus-box,.mc-terms-box,[data-mc-repeat-wrap]';
  function mcRelevant(records) {
    for (var i = 0; i < records.length; i++) {
      var m = records[i], t = m.target;
      if (t.nodeType !== 1) { t = t.parentElement; if (!t) continue; }
      if (t.closest && t.closest(MC_OWN)) continue;
      if (m.type === 'attributes' && t.matches && t.matches(MC_IGNORE_ATTR)) continue;
      return true;
    }
    return false;
  }

  function start() {
    cfg = readConfig();
    if (!cfg) return;
    var bodyObs = null;
    var stop = function () { if (bodyObs) { bodyObs.disconnect(); bodyObs = null; } };
    var go = function () { try { return mount(); } catch (e) { return true; } };
    if (go()) return;
    /* The body observer lives only until the widget is mounted, or for 30s on
       the product pages that do not have the field at all. */
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (go() || tries > 60) { clearInterval(timer); stop(); }   /* 60 x 500ms = 30s */
    }, 500);
    try {
      bodyObs = new MutationObserver(function (records) {
        if (mcRelevant(records) && go()) { clearInterval(timer); stop(); }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* the upload field stands on its own */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
